<template>
  <footer class="footer px-4 mx-2">
<div class="container">
        <div class="copyright">
          &copy; {{ year }}, made with
          <i class="text-danger ni favorite" /> by
          <a href="#" target="_blank">HU Estimates</a>
          to help tutors and trainers.
        </div>
      </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
